"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.7 20.6",
    width: "60.7",
    height: "20.6"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M60.2,16.5H55c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4.7V1H3v12.5l6.9,2h21.4c0.3,0,0.5,0.2,0.5,0.5 s-0.2,0.5-0.5,0.5H9.9c0,0-0.1,0-0.1,0l-7.3-2.1C2.2,14.3,2,14.1,2,13.9V0.5C2,0.2,2.3,0,2.5,0h57.7c0.3,0,0.5,0.2,0.5,0.5V16 C60.7,16.3,60.5,16.5,60.2,16.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M5,18.8c-0.3,0-0.5-0.2-0.5-0.5v-3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3C5.5,18.6,5.3,18.8,5,18.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M43.2,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2 C46.3,19.1,44.9,20.6,43.2,20.6z M43.2,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2S44.4,15.2,43.2,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M50.7,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2C53.9,19.1,52.4,20.6,50.7,20.6z M50.7,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S51.9,15.2,50.7,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M35.6,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2 C38.8,19.1,37.4,20.6,35.6,20.6z M35.6,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2S36.8,15.2,35.6,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "-3.5",
    y: "6.1",
    transform: "matrix(6.474092e-11 1 -1 6.474092e-11 8.6584 5.7748)",
    fill: "#EC6833",
    width: "9.9",
    height: "2.2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M2.5,12.5H0.3c-0.2,0-0.3-0.2-0.3-0.3V2.3c0-0.2,0.2-0.3,0.3-0.3h2.2c0.2,0,0.3,0.2,0.3,0.3v9.9 C2.9,12.3,2.7,12.5,2.5,12.5z M0.7,11.8h1.5V2.6H0.7V11.8z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#EC6833",
    cx: "42.8",
    cy: "8.4",
    r: "4.7"
  }));
};

exports["default"] = _default;